import {
  parseQueueArn,
  sqsInstallCommands,
  sqsInstallTerraform,
} from "@p0security/integrations-aws-sqs-shared";
import { Typography } from "@p0security/ui";

import type { AwsSqsInstaller } from "./types";

export const awsSqsInstaller: AwsSqsInstaller = {
  components: {
    "audit-log": {
      instructions: (context, id, item) => {
        const queue = parseQueueArn(id);
        if (!queue || !item?.serviceAccountId) return {};
        const args = {
          gcloudServiceAccountId: item.serviceAccountId,
          queue,
          queueArn: id,
          kmsKeyArn: item.kmsKeyArn?.trim() || undefined,
        };
        return {
          help: (
            <>
              Create P0&apos;s role in AWS account {queue.accountId} so P0 can
              send audit events to {queue.name}. Run these commands in{" "}
              <Typography.Link
                href={`https://${queue.accountId}.signin.aws.amazon.com/console`}
                target="_blank"
                rel="noopener"
              >
                AWS CloudShell
              </Typography.Link>
              , or apply the Terraform:
            </>
          ),
          commands: {
            shell: [{ command: sqsInstallCommands(context, args) }],
            iac: [{ command: sqsInstallTerraform(context, args) }],
          },
        };
      },
      items: {
        kmsKeyArn: {
          labeler: () => "KMS key ARN",
        },
        serviceAccountEmail: {},
        serviceAccountId: {},
      },
    },
  },
};
